<template>
  <main class="profile-summary">
    <!-- Header -->
    <div class="profile-summary__header">
      <div class="profile-summary__header-content">
        <h1 class="profile-summary__title">Profile Summary</h1>
        <p class="profile-summary__subtitle">Your company's public description</p>
      </div>
      <button
        class="profile-summary__edit-btn"
        @click="showProfileForm = true"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6phases7 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Edit Summary
      </button>
    </div>

    <!-- Content -->
    <div class="profile-summary__content">
      <div class="profile-summary__card">
        <div class="profile-summary__card-header">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0652 12.8512 14.2174 12.5 13.3333 12.5H6.66667C5.78261 12.5 4.93477 12.8512 4.30965 13.4763C3.68453 14.1014 3.33334 14.9493 3.33334 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 9.16667C11.841 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.841 2.5 10 2.5C8.15906 2.5 6.66667 3.99238 6.66667 5.83333C6.66667 7.67428 8.15906 9.16667 10 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Company Summary</span>
        </div>
        <p class="profile-summary__card-text">
          {{ organisationDetails.about || "No profile summary added yet. Click 'Edit Summary' to add one." }}
        </p>
      </div>
    </div>

    <!-- Edit Modal -->
    <Teleport to="#teleport-modal">
      <SideModal
        v-if="showProfileForm"
        title="Edit Profile Summary"
        subTitle="Update your company's public description"
        @close="showProfileForm = false"
        :show="showProfileForm"
        @go-back="showProfileForm = false"
        :bgChange="true"
      >
        <template v-slot:content>
          <form
            @submit.prevent="validateForm = true"
            class="profile-summary__form"
          >
            <div class="profile-summary__form-group">
              <label class="profile-summary__form-label">Summary</label>
              <TextField
                label="Write something about your company."
                height="tw-h-[176px]"
                name="about"
                :currentValue="about"
                :validate="validateForm"
                @input-changed="storeValue"
                @is-valid="handleValidation"
              />
            </div>
            <div class="profile-summary__form-actions">
              <button
                type="button"
                class="profile-summary__cancel-btn"
                @click="showProfileForm = false"
              >
                Cancel
              </button>
              <CustomButton title="Save Changes" />
            </div>
          </form>
        </template>
      </SideModal>
    </Teleport>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SideModal from "@/components/general/sidemodal/SideModal";
import TextField from "@/components/general/TextField";
import CustomButton from "@/components/general/BtnComponent";
export default {
  name: "ProfileSummary",
  data() {
    return {
      showProfileForm: false,
      about: "",
      validateForm: false,
      validationResult: [],
    };
  },
  components: {
    SideModal,
    TextField,
    CustomButton,
  },
  computed: {
    ...mapGetters("organisationModule", ["organisationDetails"]),
  },
  watch: {
    organisationDetails(val) {
      this.about = val.about;
    },
    validateForm(val) {
      if (!val) {
        setTimeout(() => {
          this.showProfileForm = false;
        }, 1000);
      }
    },
    validationResult: {
      deep: true,
      handler(val) {
        if (!val.includes(false)) {
          this.updateCompanyInfo();
        }
      },
    },
  },
  created() {
    this.getOrganisationProfile();
  },
  methods: {
    ...mapActions(["showToast"]),
    ...mapActions("organisationModule", [
      "getOrganisationProfile",
      "updateOrgDetails",
    ]),
    handleValidation(value) {
      this.validationResult.push(value);
    },
    storeValue(object) {
      this[object.name] = object.value;
    },
    async updateCompanyInfo() {
      const data = this.about;
      try {
        const response = await this.updateOrgDetails({ about: data });
        const { message } = response.data;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        this.getOrganisationProfile();
        this.showProfileForm = false;
      } catch (error) {
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-summary {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px;
    border-bottom: 1px solid #E2E8F0;
    gap: 16px;
    flex-wrap: wrap;
  }

  &__header-content {
    flex: 1;
    min-width: 200px;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }

  &__subtitle {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }

  &__edit-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: white;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      border-color: #4D84FF;
      color: #4D84FF;
    }
  }

  &__content {
    padding: 24px;
  }

  &__card {
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    padding: 20px;
  }

  &__card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    color: #64748B;

    span {
      font-family: 'DM Sans', sans-serif;
      font-size: 13px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }

  &__card-text {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 400;
    color: #0F172A;
    line-height: 1.6;
    margin: 0;
  }

  &__form {
    padding: 0 24px 24px;
  }

  &__form-group {
    margin-bottom: 24px;
  }

  &__form-label {
    display: block;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
    margin-bottom: 8px;
  }

  &__form-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
  }

  &__cancel-btn {
    padding: 10px 20px;
    background: white;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #64748B;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      border-color: #CBD5E1;
      color: #0F172A;
    }
  }
}
</style>
